const getters = {
  device: state => state.app.device,
  homeClassifyShow:state => state.app.homeClassifyShow,
  userId:state=>state.user.user_id,
  token:state=>state.user.user_token,
  userInfo:state=>state.user.user_info,
  seachKey:state=>state.goods.seachKey,
}
console.log(getters.token,'token');
export default getters
